"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
var react_1 = __importDefault(require("react"));
var Avatar_1 = require("./Avatar");
var Box_1 = require("./Box");
var core_1 = require("./core");
var Fluid_1 = require("./Fluid");
var HStack_1 = require("./HStack");
var typography_1 = require("./typography");
function Pill(_a) {
    var url = _a.url, name = _a.name, onClick = _a.onClick, _b = _a.maxWidth, maxWidth = _b === void 0 ? maxPillWidth : _b;
    var firstName = name === null || name === void 0 ? void 0 : name.split(' ')[0];
    return (react_1.default.createElement(Wrapper, { background: '$grey2', borderRadius: '$8px', height: Avatar_1.avatarSize, maxWidth: maxWidth, onClick: onClick, spaceRight: '$8px', width: '$fitContent' },
        react_1.default.createElement(HStack_1.HStack, { alignY: 'center', space: '$4px' },
            react_1.default.createElement(Avatar_1.Avatar, { title: name, url: url }),
            react_1.default.createElement(Fluid_1.Fluid, null,
                react_1.default.createElement(typography_1.Text, { color: '$grey7', singleLine: true, size: '$10px', title: name, weight: 'medium' }, firstName))),
        react_1.default.createElement(AvatarOutline, { border: '$grey5', borderRadius: '$circle', height: Avatar_1.avatarSize, width: Avatar_1.avatarSize })));
}
exports.Pill = Pill;
var maxPillWidth = (0, core_1.getCustomSize)(150);
function Wrapper(_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    return onClick ? react_1.default.createElement(Box_1.Box.Button, __assign({ onClick: onClick }, props)) : react_1.default.createElement(Box_1.Box, __assign({}, props));
}
var AvatarOutline = (0, core_1.styled)(Box_1.Box, {
    position: 'absolute',
    top: 0,
    left: 0,
});
